module.exports = __webpack_public_path__ + "static/media/middle-circle.264997f6.svg";